export const createOverviewTableRow = row => Object.assign({
  id: 0,
  counts: {},
  dealGroupings: {},
  email: '',
  isUser: false,
  teamName: '',
  name: '',
  closed: {
    currencyCode: '',
    value: 0
  },
  attainment: 0,
  goal: {
    currencyCode: '',
    value: 0
  },
  assigneeType: 'OWNER',
  totalForecastedAmount: {
    currencyCode: '',
    value: 0
  },
  forecastValue: {
    currencyCode: '',
    value: 0
  },
  forecastLastModified: null,
  isTotalRow: false,
  coverage: 0,
  isAllPipelines: false,
  isActive: true
}, row);